// ID of the container where the Mindset SDK will be rendered
export var MINDSET_CARD_ID = 'mindset-card-container';
// ID of the container for the floating panel agent
export var MINDSET_FLOATING_ID = 'mindset-floating-container';
// ID of the container for the persistent sidebar agent
export var MINDSET_SIDEBAR_ID = 'mindset-sidebar-container';
export function getAgentElement(containerId) {
  var _document$getElementB;
  return (_document$getElementB = document.getElementById(containerId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.querySelector('mindset-agent');
}